import { Input } from "@/components/ui/input";
import { Switch } from "@/components/ui/switch";
import { Panel } from "@/components/admin/Panel";

const PctField = ({ label, value, onChange, testId }) => (
  <div className="space-y-1">
    <p className="text-sm font-bold">{label}</p>
    <div className="relative max-w-[10rem]">
      <Input type="number" min={1} max={99} value={value ?? ""} onChange={(e) => onChange(e.target.value)} className="h-11 rounded-xl pr-8" data-testid={testId} />
      <span className="absolute right-3 top-1/2 -translate-y-1/2 text-sm font-bold text-muted-foreground">%</span>
    </div>
  </div>
);

export const CalculatorSettingsPanel = ({ s, setS }) => {
  const set = (k) => (v) => setS({ ...s, [k]: v });
  return (
    <Panel title="Savings calculator" testId="settings-calculator-panel">
      <div className="space-y-5">
        <label className="flex items-center gap-2 text-sm font-semibold">
          <Switch checked={!!s.savings_range} onCheckedChange={set("savings_range")} data-testid="settings-savings-range-toggle" />Show savings as a range
        </label>
        {s.savings_range ? (
          <div className="flex flex-wrap gap-4">
            <PctField label="Minimum savings %" value={s.savings_min_pct} onChange={set("savings_min_pct")} testId="settings-savings-min-input" />
            <PctField label="Maximum savings %" value={s.savings_max_pct} onChange={set("savings_max_pct")} testId="settings-savings-max-input" />
          </div>
        ) : (
          <PctField label="Savings percentage used in calculator" value={s.savings_pct} onChange={set("savings_pct")} testId="settings-savings-pct-input" />
        )}
        <PctField label="Guaranteed minimum savings %" value={s.guaranteed_min_pct} onChange={set("guaranteed_min_pct")} testId="settings-guaranteed-min-input" />
        <p className="text-xs text-muted-foreground">The buyer's price is reduced by this percentage in the home page calculator. The guaranteed minimum appears in the "at least X%" text. Click Save changes to publish.</p>
      </div>
    </Panel>
  );
};
